import React, { useState, useEffect } from 'react';
import '../../entrydoor.css';

const HingeFinish = ({ value, onChange, label = 'Hinge Finish:', swingValue }) => {
    const [selectedHingeFinish, setSelectedHingeFinish] = useState(value || "");
    const [swingType, setSwingType] = useState(""); 
    useEffect(() => {
 
        if (swingValue) {setSwingType(swingValue);}
      }, [swingValue]); 

    const handleHingeFinishChange = (e) => {
        setSelectedHingeFinish(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label htmlFor="HingeFinish">{label}</label>
            <select
                id="HingeFinish"
                value={selectedHingeFinish}
                onChange={handleHingeFinishChange}
            >
                {swingType === "Inswing" && (
                <>
                <option value="" disabled hidden>Select an option</option>
                <option value="Brass">{selectedHingeFinish === "Brass" ? "Brass ✔" : "Brass"}</option>          
                <option value="FlatBlack">{selectedHingeFinish === "FlatBlack" ? "Flat Black ✔" : "Flat Black"}</option>
                <option value="OilRubbed">{selectedHingeFinish === "OilRubbed" ? "Oil Rubbed ✔" : "Oil Rubbed"}</option>
                </>
                )}
                <option value="StainlessSteel">{selectedHingeFinish === "StainlessSteel" ? "Stainless Steel ✔" : "Stainless Steel"}</option>
                {swingType === "Inswing" && (
                <>
                <option value="BlackChrome">{selectedHingeFinish === "BlackChrome" ? "Black Chrome ✔" : "Black Chrome"}</option>
                <option value="SatinNikel">{selectedHingeFinish === "SatinNikel" ? "Satin Nikel ✔" : "Satin Nikel"}</option>
                <option value="SelfClosingZinc">{selectedHingeFinish === "SelfClosingZinc" ? "Self-Closing (Zinc) ✔" : "Self-Closing (Zinc)"}</option>
                <option value="AdjustableHingeBlack">{selectedHingeFinish === "AdjustableHingeBlack" ? "Adjustable Hinge Black ✔" : "Adjustable Hinge Black"}</option>
                <option value="AdjustableHingeSatinNikel">{selectedHingeFinish === "AdjustableHingeSatinNikel" ? "Adjustable Hinge Satin Nikel ✔" : "Adjustable Hinge Satin Nikel"}</option>
                <option value="AdjustableHingeBlackBrass">{selectedHingeFinish === "AdjustableHingeBlackBrass" ? "Adjustable Hinge Black Brass ✔" : "Adjustable Hinge Black Brass"}</option>
                <option value="ContemporarySquareBarrelHingesFlatBlack">
                    {selectedHingeFinish === "ContemporarySquareBarrelHingesFlatBlack" ? 
                    "Contemporary Square Barrel Hinges Flat Black ✔" : 
                    "Contemporary Square Barrel Hinges Flat Black"}
                </option>
                <option value="ContemporarySquareBarrelHingesSatinNikel">
                    {selectedHingeFinish === "ContemporarySquareBarrelHingesSatinNikel" ? 
                    "Contemporary Square Barrel Hinges Satin Nikel ✔" : 
                    "Contemporary Square Barrel Hinges Satin Nikel"}
                </option>
                <option value="3WayAdustableConcealedBlackHinges">
                    {selectedHingeFinish === "3WayAdustableConcealedBlackHinges" ? 
                    "3-Way Adustable Concealed Black Hinges ✔" : 
                    "3-Way Adustable Concealed Black Hinges"}
                </option>
                </>
                )}
            </select>
        </div>
    );
};

export default HingeFinish;
